var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#facebook';
                    var viewUrl = 'svg/global.svg#view-facebook';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };